/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Sandy_Puma_FlyInputs */

const en_wild_sandy_puma_fly = /** @type {(inputs: Wild_Sandy_Puma_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_wild_sandy_puma_fly = /** @type {(inputs: Wild_Sandy_Puma_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Wild_Sandy_Puma_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_sandy_puma_fly = /** @type {((inputs?: Wild_Sandy_Puma_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Sandy_Puma_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_sandy_puma_fly(inputs)
	return de_wild_sandy_puma_fly(inputs)
});